import { useCallback, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

type UseSearchState = (key: string, defaultValue: string) => [string, (value: string) => void];

export const useSearchState: UseSearchState = (key, defaultValue) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const value = searchParams.get(key) ?? defaultValue;

  const setValue = useCallback(
    (newValue: string) => {
      const newParams = new URLSearchParams(searchParams);
      newParams.set(key, newValue);
      setSearchParams(newParams, { replace: true });
    },
    [key, searchParams, setSearchParams]
  );

  useEffect(() => {
    if (!searchParams.has(key)) {
      setValue(defaultValue);
    }
  }, [key, defaultValue, setValue, searchParams]);

  return [value ?? defaultValue, setValue];
};
